import * as React from "react";
import { Link } from "react-router-dom";

interface NavLink {
  to: string;
  closeMenu: () => any;
  isOpen: boolean;
  children: React.ReactNode;
}

const NavLink: React.FC<NavLink> = (props: NavLink) => {
  const { to, closeMenu, isOpen, children } = props;

  return (
    <Link
      to={to}
      className="block text-dw-blue font-bold text-18 tracking-wide mb-3"
      onClick={closeMenu}
      tabIndex={isOpen ? 0 : -1}
    >
      {children}
    </Link>
  );
};

export default NavLink;
